import React from "react";
import Question from "./Question";
import Visuals from "./Visuals";
import Stats from "./Stats";

function Interaction() {
  return (
    <div>
      <Question />
      <Visuals />
      <Stats />
    </div>
  );
}

export default Interaction;
